<template lang="html">
  <v-app>
    <v-content :class="[`white`]">
      <div class="d-flex fill-height" style="flex-direction: column; height: 100%;">
        <div class="d-flex" style="flex: 1 1 auto;">
          <div class="ma-auto text-center">
            <img src="@/assets/images/v2/img/store_not_found.png" alt="Store Not Available" height="280" class="mb-6">
            <div class="mb-2 font-weight-bold" style="font-size: 24px;">
              Resto tidak ditemukan
            </div>
            <div>
              Pastikan link resto sudah benar
            </div>
          </div>
        </div>
        <div class="d-flex pa-6">
          <div class="ma-auto text-center">
            <div>
              Powered by
            </div>
            <img src="@/assets/images/v2/img/olsera_logo.png" alt="Olsera" height="34">
          </div>
        </div>
      </div>
    </v-content>
  </v-app>
</template>
<script>
import '@/assets/sass/v2/variables.sass'
export default {
}
</script>
